import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContent } from '../contexts/ContentContext';
const SupportButton = ({ variant = 'subtle', className = '', showText = false }) => {
    var _a;
    const { content } = useContent();
    // Don't render if support buttons are hidden
    if (!((_a = content === null || content === void 0 ? void 0 : content.supportButtons) === null || _a === void 0 ? void 0 : _a.visible)) {
        return null;
    }
    const handleDonateClick = () => {
        window.open('https://www.buymeacoffee.com/wholemomma', '_blank');
    };
    const baseClasses = "transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-opacity-50";
    const variants = {
        subtle: "bg-amber-600 hover:bg-amber-700 text-white rounded-full p-2",
        prominent: "bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-lg px-4 py-2 shadow-lg hover:shadow-xl",
        inline: "text-amber-600 hover:text-amber-700 underline hover:no-underline"
    };
    const iconVariants = {
        subtle: (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: _jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }) })),
        prominent: (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "currentColor", className: "mr-2", children: _jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }) })),
        inline: null
    };
    return (_jsxs("button", { onClick: handleDonateClick, className: `${baseClasses} ${variants[variant]} ${className}`, title: "Support Madison's Work", children: [variant !== 'inline' && iconVariants[variant], showText && (_jsx("span", { className: "font-medium", children: variant === 'prominent' ? 'Support Madison' : 'Support' })), variant === 'inline' && 'Support Madison'] }));
};
export default SupportButton;
